import constants from "../constants";
import Spinner from "./Spinner";
import {h} from "preact";
import {useState} from "preact/hooks";
import aiService from "../service/aiService";

export default function AiOnboarder({onClose, importItems}) {
  const [isLoading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);

  function newUpload() {
    setSections([]);
  }

  function addToDesign() {
    const items = [];
    sections
      .forEach(section => {
        section.items
          .filter(it => it.selected)
          .forEach(item => {
            items.push({
              name: item.name,
              description: item.description,
              prices: [{
                displayPrice: `${item.prices[0]}`,
                price: `${item.prices[0]}`
              }]
            })
          })
      })
    importItems(items);
    onClose();
  }

  function onAiUploadChange(event) {
    const files = event.target.files;
    const formData = new FormData();
    Array.from(Array(files.length).keys())
      .map(x => {
        formData.append('images', files[x], files[x].name);
      });

    setLoading(true);

    aiService.onboardMenu(formData).then(resp => {
      try {
        const response = resp.data.response
          .replace(/\n/g, '')
          .replace(/json/g, '');
        const menu = JSON.parse(response);
        setSections(menu.menu);
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    })
  }

  function selectSection(section) {
    section.selected = !section.selected;
    section.items.forEach(it => it.selected = section.selected);
    setSections([...sections]);
  }

  function selectItem(item) {
    item.selected = !item.selected;
    setSections([...sections]);
  }

  return <div className={"ai-onboard"}>
    {isLoading && <Spinner/>}

    {!isLoading && sections.length === 0 && <div className={"upload"}>
      <svg>
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-uploads"}/>
      </svg>
      <h4>Upload Menu</h4>
      <h6>Get PDF or Photo of Menu. Max 2 pages</h6>

      <div className={"box"}>
        <input type="file" name="image" onChange={onAiUploadChange} className="input-file" multiple/>
        <a className="btn primary medium">
          <span>Choose Menu</span>
        </a>
      </div>
    </div>}

    {!isLoading && sections.length > 0 && <div className={"sections"}>
      {sections.map(section => <div className={"sec"}>
        <div className="mii-section-selector">
          <label className="container">
            <input type="checkbox" onClick={() => selectSection(section)}/>
            <span className="checkmark"></span>
          </label>
        </div>

        <div className={"items"}>
          {section.items.map(item => <div className={`item ${item.selected ? "sel" : ""}`} onClick={() => selectItem(item)}>
            <h6>{item.name}</h6>
          </div>)}
        </div>
      </div>)}

      <footer>
        <a className="btn accept" style={"margin-right: 10px"} onClick={newUpload}>New Upload</a>
        <a className="btn primary accept" onClick={addToDesign}>Add to Design</a>
      </footer>
    </div>}
  </div>
}
